import { Box, Stack, Typography } from "@mui/material";
import {
  DEFAULT_SALARY_ZONE,
  getZoneLabel,
} from "../../../features/talentProfile/editForms/salaries/common";

type Props = {
  /** Formatted default ("Muu Suomi") value, e.g. "12,50 €/h" or "-". */
  defaultValue: string;
  /** Zones the TES supports, e.g. ["PKS"]. When empty/undefined, only `defaultValue` is rendered. */
  zones?: string[];
  /** Formatted value per zone. A zone missing from this map falls back to "-". */
  zoneValues?: { [zone: string]: string };
};

/**
 * Renders a salary value that may be split by salary zone (e.g. PKS vs.
 * "Muu Suomi"), matching how zoned salaries are shown in the talent's
 * salary overview (`TalentShiftSalaries`).
 *
 * When the TES doesn't support any zones, this simply renders `defaultValue`.
 */
export const ZonedSalaryValue = ({ defaultValue, zones, zoneValues }: Props) => {
  if (!zones || zones.length === 0) {
    return <>{defaultValue}</>;
  }

  const rows = [
    { label: DEFAULT_SALARY_ZONE, value: defaultValue },
    ...zones.map((zone) => ({
      label: getZoneLabel(zone),
      value: zoneValues?.[zone] || "-",
    })),
  ];

  return (
    <Stack spacing={0.25}>
      {rows.map((row) => (
        <Typography key={row.label} variant="inherit">
          <Box component="span" color="text.secondary">
            {row.label}:{" "}
          </Box>
          {row.value}
        </Typography>
      ))}
    </Stack>
  );
};

export default ZonedSalaryValue;
